export default __webpack_public_path__ + "images/0f29e6b1310597785ecbed191dd05d18.png";